// eslint-disable-next-line import/prefer-default-export
export const NotificationType = Object.freeze({
    // Manager notifications
    willStartNotifIdToManager: 0,
    hasStartedNotifIdToManager: 1,
    willEndNotifIdToManager: 2,
    hasEndedNotifIdToManager: 3,
    autoApprovedNotifIdToManager: 4,
    autoSignOffAndPublishNotifIdToManager: 17,

    // Employee notifications (common)
    approvedNotifIdToEmployee: 10,
    refusedNotifIdToEmployee: 11,
    unawardedNotifIdToEmployee: 12,
    cancelledNotifIdToEmployee: 13,
    willEndNotifIdToEmployee: 8,
    hasEndedNotifIdToEmployee: 9,
    rankChangeNotifIdToEmployee: 18,
    removedFromBidNotifIdToEmployee: 19,

    // Employee notifications (preferential only)
    preferentialWillStartNotifIdToEmployee: 5,
    preferentialHasStartedNotifIdToEmployee: 6,
    preferentialDraftMadeNotifIdToEmployee: 7,

    // Employee notifications (sequential only)
    sequentialTurnWillStartNotifIdToEmployee: 14,
    sequentialTurnHasStartedNotifIdToEmployee: 15,
    sequentialTurnHasEndedNotifIdToEmployee: 16,
});
